import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import ArrowLeftSVG from "../../../../../media/images/icons/arrow-left";
import ActivitiesWallet from "../../../../../media/images/icons/activities-wallet";
import ClockFillSVG from "../../../../../media/images/icons/clockfill";
import RoutingSVG from "../../../../../media/images/icons/routing-icon";
import ReplaceBoxs from "../../../../../media/images/icons/replace-boxs";

export default function Activities() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: "background.default",
        // border: "1px solid gray",
        padding: "8px",
        borderRadius: "16px",
        boxShadow: "0px 4px 8px 3px rgba(0,0,0,0.1)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography>فعالیت شما در یک نگاه</Typography>
        <Link
          to={"#"}
          style={{
            backgroundColor: "#F3DDC1",
            display: "flex",
            alignItems: "center",
            borderColor: theme.palette.secondary.dark,
            borderWidth: "1px",
            borderStyle: "solid",
            borderRadius: "8px",
            padding: "4px",
          }}
        >
          <Typography
            sx={{
              color: "secondary.dark",
            }}
          >
            مشاهده آمار فعالیت
          </Typography>
          <ArrowLeftSVG color={theme.palette.secondary.dark} />
        </Link>
      </Box>
      <Box
        sx={{
          display: "flex",
          //   alignItems: "center",
          gap: "8px",
          mt: 2,
        }}
      >
        <Box
          sx={{
            // border: "1px solid gray",
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            backgroundColor: "info.light",
            borderRadius: "16px",
            padding: "16px 8px",
          }}
        >
          <ActivitiesWallet color={theme.palette.secondary.dark} />
          <Typography noWrap>1,050,000,000 ریال</Typography>
        </Box>
        <Box
          sx={{
            // border: "1px solid gray",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              //   border: "1px solid gray",
              borderRadius: "8px",
              backgroundColor: "info.light",
              justifyContent: "center",
            }}
          >
            <ClockFillSVG color={theme.palette.secondary.dark} />
            <Typography noWrap>565,500 ساعت</Typography>
          </Box>
          <Box
            sx={{
              flex: 1,
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              //   border: "1px solid gray",
              backgroundColor: "info.light",
              justifyContent: "center",
            }}
          >
            <ReplaceBoxs color={theme.palette.secondary.dark} />
            <Typography>15550 تن</Typography>
          </Box>
        </Box>
        <Box
          sx={{
            // border: "1px solid gray",
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            backgroundColor: "info.light",
            borderRadius: "16px",
            padding: "16px 8px",
          }}
        >
          <RoutingSVG color={theme.palette.secondary.dark} />
          <Typography noWrap>80000 کیلومتر</Typography>
        </Box>
      </Box>
    </Box>
  );
}
